// src/components/Publication.js
import React, { useEffect, useState } from "react";
import axios from "axios";

const Publication = () => {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch publications from backend
  useEffect(() => {
    const fetchPublications = async () => {
      try {
        const response = await axios.get(
          "https://admin.stipsredu.in/publications/all"
        );

        if (response.data.success) {
          setPublications(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching publications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPublications();
  }, []);

  return (
    <section className="w-full bg-gradient-to-b from-[#ffffff] to-[#f1f5ff] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block mb-4 px-4 py-1 text-sm font-semibold text-white bg-[#112E65] rounded-full">
            Research Publications
          </span>
          <h2 className="text-4xl font-bold text-[#112E65] mb-6">
            Advancing Pharmaceutical Sciences
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Our faculty and students actively contribute to pharmaceutical
            research through publications in reputed national and international
            journals.
          </p>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="text-center text-gray-500">
            Loading publications...
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {publications.length > 0 ? (
              publications.map((pub) => (
                <div
                  key={pub._id}
                  className="bg-white rounded-2xl shadow-lg p-8 border-l-4 border-[#112E65] hover:shadow-xl transition"
                >
                  <h3 className="text-lg font-semibold text-[#112E65] mb-2">
                    {pub.title}
                  </h3>

                  <p className="text-sm text-gray-700 mb-1">
                    <span className="font-medium">Authors:</span>{" "}
                    {pub.authors}
                  </p>

                  <p className="text-sm text-gray-600 mb-1">
                    <span className="font-medium">
                      Journal/Conference:
                    </span>{" "}
                    {pub.journalConference}
                  </p>

                  <p className="text-sm text-gray-600 mb-1">
                    <span className="font-medium">Published By:</span>{" "}
                    {pub.publishedBy}
                  </p>

                  <p className="text-sm text-gray-600 mb-1">
                    <span className="font-medium">Year:</span> {pub.year}
                  </p>

                  <p className="text-sm text-gray-500 mt-2">
                    {pub.description}
                  </p>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center text-gray-500">
                No publications available at the moment.
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Publication;